import { Chip, Listbox, ListboxItem, Selection } from '@nextui-org/react';
import { FaAngleRight } from 'react-icons/fa6';
import ChatListItem from './ChatListItem';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectBotDetails, selectChats } from '../../store/chat/chatSlice';
import {
  selectActiveClients,
  selectCurrentClient,
  setCurrentClient,
} from '../../store/client/clientSlice';
import { ActorType, Client } from '../../types';
import { FaTelegram } from 'react-icons/fa6';
import Icon from '../base/Icon';
import { useEffect } from 'react';
import { botDetails } from '../../store/chat/chatThunks';

const actorTypes: Set<ActorType> = new Set([
  'suicidal_medium',
  'suicidal_high',
  'grieving',
  'stressed',
  'lonely',
  'health_concern',
  'heartbroken',
  'addicted',
  'traumatised',
  'paranoid',
  'abused',
  'parent',
  'body_image',
  'bored',
  'elderly_SOS',
  'grief_SOS',
  'alcoholism_SOS',
  'friendship_rejection_SOS',
  'concerned_son_SOS',
  'concerned_girlfriend_SOS',
  'non_binary_SOS',
  'concerned_friend_SOS',
  'harassment_SOS',
  'overwork_SOS',
  'delusional_SOS',
  'borderline_PD_SOS',
  'isolation_SOS',
  'heartbroken_SOS',
  'unemployment_SOS',
  'caregiver_SOS',
  'transgender_SOS',
  'teacher_SOS',
  'mindline_alice',
  'mindline_amos',
  'mindline_dwight',
]);

export function isActorType(value: string | undefined): value is ActorType {
  return value !== null && actorTypes.has(value as ActorType);
}

export default function ChatListClients() {
  const dispatch = useAppDispatch();
  const chats = useAppSelector(selectChats);
  const currentClient = useAppSelector(selectCurrentClient);
  const activeClients = useAppSelector(selectActiveClients);

  const autoSaveClients = activeClients.filter((u) => u.userType === 'client');

  useEffect(() => {
    dispatch(botDetails());
  }, [dispatch]);

  const bot = useAppSelector(selectBotDetails);

  const handleSelectionChange = (keys: Selection) => {
    if (keys === 'all') {
      return;
    }
    for (const k of keys.values()) {
      const userId = k.toString();
      dispatch(setCurrentClient(userId));
    }
  };

  const ChatListClientsList = ({
    clients,
    ariaLabel,
  }: {
    clients: Client[];
    ariaLabel: string;
  }) => (
    <Listbox
      items={clients}
      itemClasses={{ base: 'rounded-medium' }}
      variant="flat"
      selectionMode="single"
      selectedKeys={currentClient?.userId ? [currentClient.userId] : []}
      onSelectionChange={handleSelectionChange}
      emptyContent={<p>No chats.</p>}
      aria-label={ariaLabel}
    >
      {(c) => (
        <ListboxItem
          key={c.userId}
          textValue={c.userId}
          selectedIcon={(props) =>
            props.isSelected && <Icon icon={FaAngleRight} className="w-3 h-3" />
          }
          className={`${currentClient ? (c.userId === currentClient.userId ? 'highlight-list-item' : '') : ''}`}
        >
          <ChatListItem
            client={c}
            messages={chats[c.userId]?.messagesWithClient}
          />
        </ListboxItem>
      )}
    </Listbox>
  );

  return (
    <div className="flex flex-1 flex-col justify-between gap-2 mb-2">
      {process.env.REACT_APP_DEPLOYMENT_TYPE === 'GENERIC' && (
        <ChatListClientsList
          clients={autoSaveClients}
          ariaLabel="Active clients chat list"
        />
      )}
      {process.env.REACT_APP_DEPLOYMENT_TYPE === 'SOS' && (
        <ChatListClientsList
          clients={autoSaveClients}
          ariaLabel="Active clients chat list"
        />
      )}

      <div>
        <p className="bot-info">Search in Telegram to start chatting:</p>
        <Chip
          className="telegram-name"
          startContent={<Icon icon={FaTelegram} className="w-5 h-5" />}
        >
          {bot.username}
        </Chip>
      </div>
    </div>
  );
}
